import { render, staticRenderFns } from "./AdvertiserPanelPTP.vue?vue&type=template&id=152c9f82&"
import script from "./AdvertiserPanelPTP.vue?vue&type=script&lang=js&"
export * from "./AdvertiserPanelPTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports